var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.userPermissions.indexOf("add_location_departments") > -1
        ? _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-header-top-container" }, [
              _c("div", { staticClass: "page-name" }, [
                _vm._v(_vm._s(_vm.pageTitle))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "back_button btn btn-primary pull-right",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Back")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _c("form", { attrs: { id: "benefitForm" } }, [
                _c("div", { staticClass: "forms-container" }, [
                  _c("div", { staticClass: "row no-margin" }, [
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.name,
                                expression: "name"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "name",
                              placeholder: "Name"
                            },
                            domProps: { value: _vm.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.name = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.nameError))
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 forms-block" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("vue-dropzone", {
                            ref: "dropzone",
                            attrs: {
                              id: "drop1",
                              options: _vm.dropzoneOptions,
                              destroyDropzone: false,
                              headers: _vm.dropzoneOptions.headers,
                              name: "file"
                            },
                            on: {
                              "vdropzone-removed-file": _vm.removedSelectedFile,
                              "vdropzone-success": _vm.vfileSuccess,
                              "vdropzone-duplicate-file": _vm.vduplicateFile
                            }
                          }),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.imageError))
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _c("strong", {
                              staticClass: "error text-danger",
                              attrs: { id: "errorMsg2" }
                            })
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "col-12 paddingleft0" }, [
                        _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "addCompanyBtn",
                            type: "submit",
                            value: "Save"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addCompany()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "addAndContinueCompanyBtn",
                            type: "submit",
                            value: "Save and Continue"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addCompany(
                                (_vm.flag = "Save and Continue")
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "back_button btn btn-primary",
                          attrs: {
                            id: "cancelCompany",
                            type: "submit",
                            value: "Cancel"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.buttonBack.apply(null, arguments)
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("\n            Oops...!\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _vm._v(
                "\n            Sorry, You don't have permission to access this page.\n        "
              )
            ])
          ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "name" } }, [
        _vm._v("Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop1" } }, [
        _vm._v("Upload Logo :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9842a7c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9842a7c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/ManageCompany/AddCompany.vue
// module id = null
// module chunks = 